import { BotIcon as Robot, Zap, FileText } from "lucide-react";
import React from "react";

export function WhyMinEMI() {
  const reasons = [
    {
      icon: <Robot className="h-12 w-12 text-white" />,
      title: "Your loan advisor & AI negotiator",
      description:
        "Our AI works tirelessly to find you the best rates and negotiate terms that traditional advisors might miss.",
    },
    {
      icon: <Zap className="h-12 w-12 text-white" />,
      title: "Built for speed. Approved on your terms",
      description:
        "Get instant recommendations and quick approvals without compromising on your requirements.",
    },
    {
      icon: <FileText className="h-12 w-12 text-white" />,
      title: "Paperless. No cold calls, ever",
      description:
        "Enjoy a completely digital experience with zero paperwork and no unwanted sales calls.",
    },
  ];

  return (
    <section className="bg-[#59266D] py-20 text-white">
      <div className="container px-4 px-md-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="mb-4 text-3xl font-bold tracking-wide md:text-4xl">
            Why Choose MinEMI
          </h2>
          <p className="mb-12 text-[1.16rem] tracking-wide leading-7 text-white/80">
            We're reimagining how Indians access credit with technology that
            puts you first.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {reasons.map((reason, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div
                className="mb-6 rounded-full bg-[#6A3C7C] shadow-none"
                style={{ padding: "1.25rem" }}
              >
                {reason.icon}
              </div>
              <h3 className="mb-3 text-xl font-semibold tracking-wide">
                {reason.title}
              </h3>
              <p className="text-[1.03rem] text-white/80 tracking-wide">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-[20px] bg-white/10 p-6 text-center shadow-none">
          <p className="text-lg font-medium m-0">
            Join over 50,000+ Indians who have discovered better loan options
            with MinEMI
          </p>
        </div>
      </div>
    </section>
  );
}
